<!-- App.svelte -->
<script>
  import { Router, Route, navigate } from "svelte-routing";
  import { onMount } from "svelte";
  import { ToastContainer, FlatToast } from 'svelte-toasts';
  
  import FooterSmall from "components/Footers/FooterSmall.svelte";
  import Admin from "./layouts/Admin.svelte";
  import Auth from "./layouts/Auth.svelte";
  import Landing from "./views/Landing.svelte";
  import Profile from "./views/Profile.svelte";

  import { authStore, initializeAuth } from './lib/authStore';
  let authState;
  export let url = "";
  let isInitialized = false;

  // Suscribirnos a los cambios del authStore
  authStore.subscribe(value => {
    authState = value;
    if (isInitialized) {
      handleNavigation();
    }
  });

  // Verificar y redirigir según el estado de autenticación
  function handleNavigation() {
    if (!authState.isLoading) {
      const currentPath = window.location.pathname;
      if (authState.authData) {
        if (!currentPath.startsWith('/admin')) {
          navigate('/admin/dashboard');
        }
      } else {
        if (!currentPath.startsWith('/auth')) {
          navigate('/auth/login');
        }
      }
    }
  }

  onMount(async () => {
    await initializeAuth();
    isInitialized = true;
    handleNavigation();
  });
</script>

<Router url="{url}">
  <!-- Contenedor de toasts -->
  <ToastContainer let:data={data}>
    <FlatToast {data} />
  </ToastContainer>

  <!-- Rutas de autenticación -->
  <Route path="auth/*auth" component="{Auth}" />

  <!-- Páginas sin layout -->
  <Route path="landing" component="{Landing}" />
  <Route path="profile" component="{Profile}" />

  <!-- Rutas de administrador -->
  <Route path="admin/*admin" component="{Admin}" />
</Router>